module.exports = __webpack_public_path__ + "static/cowildbeesIcon-e354edfd6655cb11236fdb37ae369945.png";